export const cleanText = (text, isUppercase = true) => {
    text = text.replace(/(\r\n|\n|\r)/gm, ' ');
    text = text.replace(/[-–—]/g, ' ');
    text = text.replace(/\s{2,}/g, ' ');
    text = text.replace(/[[\].,/#!?¿!¡$%^&*;':{}=_"”“’`…~()]/g, '');
    text = text.replace(/ +(?= )/g, '');
    text = isUppercase ? text.toUpperCase() : text;
    return text;
  };